// todo implement web
export const ScannerScreen = () => null
